export const DESIGN_SERVICES = "DESIGN_SERVICES"
export const DEVELOPMENT_SERVICES = "DEVELOPMENT_SERVICES"
export const SEO_SERVICES = "SEO_SERVICES"